import React from "react";
import { number } from "prop-types";

import "./playIcon.m.css";

const PlayIcon = ({ width = 15, height = 15 }) => (
  <div styleName="wrapper">
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 42 42">
      <g transform="translate(.467)">
        <path d="M0 0H42V42H0z" transform="translate(-.467)" fill="transparent" />
        <g transform="translate(.51 .977)">
          <path
            d="M24.023 4a20.023 20.023 0 1 0 20.024 20.023A20.018 20.018 0 0 0 24.023 4zm-4 29.034V15.013l12.014 9.01z"
            transform="translate(-4 -4)"
            fill="#35144f"
          />
        </g>
      </g>
    </svg>
  </div>
);

PlayIcon.propTypes = {
  width: number,
  height: number,
};

export default PlayIcon;
